import { render, staticRenderFns } from "./ShootingsItem.vue?vue&type=template&id=c4532526&scoped=true"
import script from "./ShootingsItem.vue?vue&type=script&lang=ts"
export * from "./ShootingsItem.vue?vue&type=script&lang=ts"
import style0 from "./ShootingsItem.vue?vue&type=style&index=0&id=c4532526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4532526",
  null
  
)

export default component.exports